var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.productName.length < 30)?_c('h2',[_vm._v("\n  "+_vm._s(_vm.productName)+"\n")]):_c('h2',{attrs:{"title":_vm.productName}},[_vm._v("\n  "+_vm._s(_vm.productName.substr(0, 30) + "...")+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }